import TopNavQuoteRequestDetails from "./TopNavQuoteRequestDetails";
import TopNavQuickRequestDetails from "./TopNavQuickRequestDetails";

interface TopNavQuickQuoteProps {
  data: any;
  isQuickRequest: boolean;
}

function TopNavQuickQuote({ data, isQuickRequest }: TopNavQuickQuoteProps) {
  if (isQuickRequest) {
    return <TopNavQuickRequestDetails data={data} />;
  }
  return <TopNavQuoteRequestDetails data={data} />;
}

export default TopNavQuickQuote;
